import { Lots } from "./Lots";
import { LotPeople } from "./people";
import { ReactComponent as Background } from "./plan-background.svg";
import { ReactComponent as Drawings } from "./plan-drawings.svg";

interface MapProps {
  onClick?: (lot: LotPeople) => void;
}

export function Map({ onClick }: MapProps) {
  return (
    <div className="relative w-full">
      <Background className="block h-auto w-full" />

      <div className="pointer-events-none absolute inset-0">
        <Drawings className="h-full w-full" />
      </div>
      <div className="absolute inset-0">
        <Lots onClick={onClick} />
      </div>
    </div>
  );
}
